import {
  AccountManagerColumn,
} from '../../../../sources/charting_library.min';
import {
  StandardFormatterName,
} from '../../../../sources/charting_library';
import { ITVHolding } from './types';

type TCustomizedAccountManagerColumn =
  AccountManagerColumn & { property: keyof ITVHolding }

export const holdingTableColumns: TCustomizedAccountManagerColumn[] = [
  {
    id: 'customSymbol',
    label: 'Symbol',
    formatter: StandardFormatterName.Symbol,
    property: 'customSymbol',
    dataFields: ['customSymbol', 'customSymbol'],
  },
  {
    id: 'buyQty',
    label: 'Net Quantity',
    property: 'buyQty',
    alignment: 'right',
    dataFields: ['buyQty'],
  },
  {
    id: 'netAvgPrice',
    label: 'Avg. Price',
    property: 'netAvgPrice',
    sortProp: 'netAvgPriceSortProp',
    alignment: 'right',
    dataFields: ['netAvgPrice'],
  },
  {
    id: 'ltp',
    label: 'Last Traded Price',
    property: 'ltp',
    sortProp: 'ltpSortProp',
    alignment: 'right',
    dataFields: ['ltp'],
  },
  {
    id: 'investment',
    label: 'Investment',
    property: 'investment',
    sortProp: 'investmentSortProp',
    alignment: 'right',
    dataFields: ['investment'],
  },
  {
    id: 'currentValue',
    label: 'Current Value',
    property: 'currentValue',
    sortProp: 'currentValueSortProp',
    alignment: 'right',
    dataFields: ['currentValue'],
  },
  {
    id: 'dayPnl',
    label: 'Day P&L',
    property: 'dayPnl',
    sortProp: 'dayPnlSortProp',
    alignment: 'right',
    dataFields: ['dayPnl'],
  },
  {
    id: 'dayPercentage',
    label: 'Day %',
    property: 'dayPercentage',
    alignment: 'right',
    dataFields: ['dayPercentage'],
  },
  {
    id: 'overallPnl',
    label: 'Overall P&L',
    property: 'overallPnl',
    sortProp: 'overallPnlSortProp',
    alignment: 'right',
    dataFields: ['overallPnl'],
  },
  {
    id: 'overallPercentage',
    label: 'Overall %',
    property: 'overallPercentage',
    alignment: 'right',
    dataFields: ['overallPercentage'],
  },
  {
    id: 'dematQty',
    label: 'Demat Qty.',
    property: 'dematQty',
    alignment: 'right',
    dataFields: ['dematQty'],
  },
  {
    id: 't1Qty',
    label: 'T1 Qty.',
    property: 't1Qty',
    alignment: 'right',
    dataFields: ['t1Qty'],
  },
];
